import { User } from 'src/app/shared/models/user.model';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AutomatedForms, CWSForm, RTADetails, RemoveRTAFiles,CWSRequest } from 'src/app/shared/models/solarForms.model';
import { DataSourceService } from '../data-source.service';
import { HttpParams } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class SolarFormsRepositoryService {

  constructor(private dataSource: DataSourceService) {

  }
  getAutomatedFormRequests(id: string, cwsFormOption:number): Observable<AutomatedForms[]> {
    const params = new HttpParams()
      .set('id', id)
      .set('cwsFormOption', cwsFormOption)
    return this.dataSource.getAutomatedFormRequests(id,cwsFormOption);
  }

  updateCwsForm(data: CWSForm): Observable<any> {
    return this.dataSource.updateCwsFormData(data);
  }
  postCwsForm(data: CWSForm): Observable<any> {
    return this.dataSource.postCwsFormData(data);
  }
  getAllSupplierUserAssociatedWithBuyer(cwsIdNo:string, supplierId: string): Observable<any> {
    return this.dataSource.getAllSupplierUserAssociatedWithBuyer(cwsIdNo, supplierId)
  }
  getAllAssociatedBuyersWithSupplier(cwsIdNo:string): Observable<any> {
    return this.dataSource.getAllAssociatedBuyersWithSupplier(cwsIdNo)
  }
  getBuyersBySupplierId(cwsId: string, supplierId: string): Observable<any> {
    return this.dataSource.getBuyersBySupplierId(cwsId, supplierId)
  }
  getSuppliersByBuyerId(cwsId : string): Observable<any> {
    return this.dataSource.getSuppliersByBuyerId(cwsId);
  }
  getAutomatedFormRequestById(requestId : string): Observable<any> {
    return this.dataSource.getAutomatedFormRequestById(requestId);
  }
  getAutomatedRequestFormByCwsNumber(data : any, tokenData:any): Observable<CWSForm> {
    return this.dataSource.getAutomatedRequestFormByCwsNumber(data, tokenData);
  }

  updateExternalFormData(data: any, token, expires): Observable<any> {
    return this.dataSource.updateExternalFormData(data, token, expires);
  }

  resendCWSNotification(formId: string): Observable<any> {
    return this.dataSource.resendCWSNotification(formId);
  }

  getPPAPReadOnlyDetails(data: string): Observable<any> {
    return this.dataSource.getPPAPReadOnlyDetails(data);
  }

  submitPPAPForm(data): Observable<any> {
    return this.dataSource.submitPPAPForm(data);
  }
  savePPAPForm(data): Observable<any> {
    return this.dataSource.savePPAPForm(data);
  }

  uploadRTAContent(data:FormData): Observable<any> {
    return this.dataSource.uploadRTAContent(data);
  }

  saveRTAFormInfo(RTAFormInfo: RTADetails): Observable<any> {
    return this.dataSource.saveRTAFormDetails(RTAFormInfo);
  }

  updateRTAFormDetails(RTAFormInfo: RTADetails): Observable<any> {
    return this.dataSource.updateRTAFormDetails(RTAFormInfo);
  }

  getRTAFormDetailsById(requestId : string): Observable<any> {
    return this.dataSource.getRTAFormDetailsById(requestId);
  }

  removeRTAFiles(removeRTAFile: RemoveRTAFiles): Observable<RemoveRTAFiles> {
    return this.dataSource.removeRTAFiles(removeRTAFile);
  }
  
}
